import { useCallback, useState } from 'react';
import { TimekeeperService } from 'services/TimekeeperService';
import { BreakRule } from 'repository/timekeeper/@types/BreakRuleModel';

const timekeeperService = new TimekeeperService();

export const useRestParametersQuery = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<BreakRule[]>([]);

    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            const data = await timekeeperService.break_rule.getBreakRules();
            const orderedData = data.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }));
            setRows(orderedData as BreakRule[]);
        } catch (error) {
            console.error('Error loading break rules:', error);
            setLoading(false);
            setRows([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return { loading, setRows, rows, setLoading, loadData };
};
